import { BannerMessage, ModalMessage, InteractionEvent, DeliveryPreferences } from "../../model/in-app-comms-model"

export const InAppCommsActionTypes = {
    API_ATTEMPT:          "@@in-app-comms/API_ATTEMPT",
    API_FAILURE:          "@@in-app-comms/API_FAILURE",
    SET_UNAVAILABLE:      "@@in-app-comms/SET_UNAVAILABLE",
    SET_DELIVERY_PAYLOAD: "@@in-app-comms/SET_DELIVERY_PAYLOAD",
    SET_NOT_REGISTERED:   "@@in-app-comms/SET_NOT_REGISTERED",
    SET_PREFERENCES:      "@@in-app-comms/SET_PREFERENCES",
    SET_PREFERENCES_ERROR: "@@in-app-comms/SET_PREFERENCES_ERROR",
    QUEUE_EVENT:          "@@in-app-comms/QUEUE_EVENT",
    DEQUEUE_EVENTS:       "@@in-app-comms/DEQUEUE_EVENTS",
    CLEAR_EVENT_QUEUE:    "@@in-app-comms/CLEAR_EVENT_QUEUE",
    DISMISS_MODAL:        "@@in-app-comms/DISMISS_MODAL",
    RESET:                "@@in-app-comms/RESET",
}

export interface InAppCommsState {
    readonly loading: boolean
    readonly error: Error | null
    // True once a delivery/preferences call returns HTTP 501, meaning the SL
    // server has no in-app-comms layer configured. The feature is then treated
    // as unavailable rather than errored, and the UI degrades gracefully.
    readonly unavailable: boolean
    // True while the server answers 503 and its registration status is 404:
    // an on-prem system that has not been registered with PacBio. That is not a
    // delivery failure, so it is kept apart from `error`.
    readonly notRegistered: boolean
    readonly banner: BannerMessage | null
    readonly modal: ModalMessage | null
    readonly preferences: DeliveryPreferences | null
    // Why the last preferences fetch failed, for the Communication Preferences
    // page to show instead of an endless spinner. Null when none has failed.
    readonly preferencesError: string | null
    readonly pendingEvents: InteractionEvent[]
    // IDs of modals the user has dismissed this session. Prevents a poll
    // response that arrives before the server has processed the dismiss from
    // re-populating the modal. Not persisted — intentionally session-scoped.
    readonly dismissedModalIds: string[]
}
